import React from "react";
import { Button, Container } from "react-bootstrap";
import "../css/Login.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Instagram from "../imagenes/instagram.png";
import Facebook from "../imagenes/facebook.png";
import Linkelin from "../imagenes/linkelin.png";

const Login = ({ handleLogin }) => {
  return (
    <Container fluid className="background-container-login">
      <div className="logo-container" />

      <div className="content">
        <h1 className="text-center">Bienvenido al Portal Web Netjer Networks</h1>
        <p className="description-text text-center">
          Al hacer clic en "Iniciar sesión", tendrás acceso a información crucial sobre Netjer Networks México.<br />
          Descubre detalles exclusivos, actualizaciones importantes y recursos esenciales para maximizar tu experiencia con nosotros.<br />
          ¡Únete ahora y explora todo lo que Netjer Networks tiene para ofrecerte en México!
        </p>

        <div className="text-center">
          <Button onClick={handleLogin} className="boton">
            Iniciar Sesión
          </Button>
        </div>

        <div className="social-icons text-center mt-4">
          <a href="https://www.instagram.com/netjernetworks" target="_blank" rel="noopener noreferrer">
            <img src={Instagram} className="rsociales" alt="Instagram" />
          </a>
          <a href="https://www.facebook.com/NetjerNetworks?locale=es_LA" target="_blank" rel="noopener noreferrer">
            <img src={Facebook} className="rsociales" alt="Facebook" />
          </a>
          <a href="https://www.linkedin.com/company/netjernetworks/" target="_blank" rel="noopener noreferrer">
            <img src={Linkelin} className="rsociales" alt="LinkedIn" />
          </a>
        </div>
      </div>
    </Container>
  );
};

export default Login;
